import React from 'react';
import { Typography, Stack, Button } from '@mui/material';
import BodyPartImage from '../assets/icons/body-part.png';
import TargetImage from '../assets/icons/target.png';
import EquipmentImage from '../assets/icons/equipment.png';

const Detail = ({ exerciseDetail }) => {
  const { bodyPart, gifUrl, name, target, equipment } = exerciseDetail;

  const extraDetail = [
    {
      icon: BodyPartImage,
      name: bodyPart,
    },
    {
      icon: TargetImage,
      name: target,
    },
    {
      icon: EquipmentImage,
      name: equipment,
    },
  ];

  return (
    <Stack
      gap="60px"
      sx={{
        flexDirection: { lg: 'row' },
        p: '20px',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <img src={gifUrl} alt={name} loading="lazy" className="detail-image" />

      <Stack
        sx={{ gap: { lg: '35px', xs: '20px' } }}
        mt="165px"
        className="detailsExo"
      >
        <Typography
          variant="h4"
          texttransform="capitalize"
          className="titleExo"
        >
          {name}
        </Typography>
        <Typography variant="h6">
          This exercise {name}
          is gonna target your {target}.
        </Typography>
        {extraDetail.map((item) => (
          <Stack key={item.name} direction="row" gap="20px" alignItems="center">
            <Button
              className="btnImage"
              sx={{
                background: '#1b1b1b',
                borderRadius: '50%',
                border: '1px solid #ff2625',
                width: '100px',
                height: '100px',
              }}
            >
              <img src={item.icon} alt={bodyPart} />
            </Button>

            <Typography variant="h6" texttransform="capitalize">
              {item.name}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};

export default Detail;
